import {Router} from "@angular/router";
import {PageHeaderItem} from "@share/component/page-header/page-header";

/**
 * Utilitaire pour la gestion des onglets
 *
 * @author Lionel Gimenez
 * @date 16/09/2025
 */
export class TabUtils {
    /**
     * Détermine l'index de l'onglet actif en fonction de l'URL actuelle
     *
     * @param router Router Angular
     * @param tabItems Liste des onglets disponibles
     * @param defaultIndex Index par défaut si aucun onglet ne correspond à l'URL (0 par défaut)
     * @returns L'index de l'onglet actif
     */
    public static getSelectedTabIndexFromUrl(
        router: Router,
        tabItems: Array<PageHeaderItem>,
        defaultIndex: number = 0
    ): number {
        const currentUrl = router.url;

        //Recherche de l'onglet correspondant à l'URL actuelle
        const foundIndex = tabItems.findIndex(
            item => (item.url && currentUrl.includes(item.url)) || currentUrl.endsWith(item.code)
        );

        //Si un onglet correspondant est trouvé, on le retourne, sinon on retourne l'index par défaut
        return foundIndex !== -1 ? foundIndex : defaultIndex;
    }

    /**
     * Détermine l'onglet actif en fonction de l'URL actuelle
     *
     * @param router Router Angular
     * @param tabItems Liste des onglets disponibles
     * @param defaultIndex Index par défaut si aucun onglet ne correspond à l'URL (0 par défaut)
     * @returns L'onglet actif
     */
    public static getSelectedTabFromUrl<T extends PageHeaderItem>(
        router: Router,
        tabItems: Array<T>,
        defaultIndex: number = 0
    ): T {
        const selectedIndex = this.getSelectedTabIndexFromUrl(router, tabItems, defaultIndex);
        return tabItems[selectedIndex];
    }
}
